// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const TheadWithTooltip = styled.div`
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    .pul-icon {
        margin-left: 5px;
    }
`;
